<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list nav>
        <v-list-item :to="{ name: 'dashboard' }">
          <v-list-item-action>
            <v-icon color="orange">mdi-account-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Clients</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'createClient' }">
          <v-list-item-action>
            <v-icon color="green">mdi-account-plus</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Nouveau client</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'statistiques' }">
          <v-list-item-action>
            <v-icon color="purple">mdi-chart-bar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Statistiques</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'exports' }">
          <v-list-item-action>
            <v-icon color="cyan">mdi-table-arrow-right</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Exports</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout">
          <v-list-item-action>
            <v-icon color="red">mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Se déconnecter</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar clipped-left app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="ml-0 pl-4">Cartes de fidélité</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon @click="$router.push({ name: 'createClient' })">
            <v-icon>mdi-account-plus</v-icon>
          </v-btn>
        </template>
        <span>Créer un nouveau client</span>
      </v-tooltip>
    </v-app-bar>

    <v-main>
      <div class="pa-5">
        <v-fade-transition mode="out-in" :duration="100">
          <router-view v-if="!loading"></router-view>
        </v-fade-transition>
      </div>
    </v-main>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import { auth } from "@/firebase";

export default {
  name: "Dashboardlayout",
  data: () => ({
    drawer: null,
    titre: "",
    recherche: "",
    loading: true,
  }),

  mounted() {
    this.getClients();
  },

  methods: {
    async getClients() {
      this.loading = true;
      await this.$store.dispatch("bindClientsRef");
      this.loading = false;
    },
    async logout() {
      await auth.signOut();
      this.$router.push("login");
    },
  },
};
</script>
